import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
document.addEventListener('click', (e) => {
    // Tìm xem cái thẻ vừa bấm có phải là link trong Menu không
    const link = e.target.closest('a'); 
    if (link) {
        const pageName = link.innerText; // Lấy chữ như "Sản phẩm", "Liên hệ"
        document.title = pageName + " - Habako M&E";
    }
});
const observer = new MutationObserver(() => {
    const pageHeading = document.querySelector('h1'); // Giả sử mỗi trang bạn đều có 1 thẻ h1
    if (pageHeading) {
        document.title = pageHeading.innerText + " | Habako M&E";
    }
});

// Bắt đầu theo dõi sự thay đổi của toàn bộ trang web
observer.observe(document.body, { childList: true, subtree: true });
root.render(
  <StrictMode>
   <HelmetProvider>
    <App />
   </HelmetProvider>
  </StrictMode>
);
